import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Table, ButtonGroup, Button, Col, Form, InputGroup} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoltLightning, faSearch, faPenToSquare, faCheck, faHourglass, faReply } from '@fortawesome/free-solid-svg-icons';
import { updateSearch, searchLeaveWithdrawalPagination, searchLeaveWithdrawalPageCount, updateCurrentPage } from '../../3.Store/LeaveWithdrawalSlice';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment/moment';
import { ThreeDots } from 'react-loader-spinner';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Pagination from '../../2.Commons/Pagination';

const LeaveWithdrawalList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const withdrawalList = useSelector(state => state.LeaveWithdrawalSlice.lists);
  const totalPages = useSelector(state => state.LeaveWithdrawalSlice.totalPages);
  const currentPage = useSelector(state => state.LeaveWithdrawalSlice.currentPage);
  const loading2 = useSelector(state => state.LeaveWithdrawalSlice.loading);
  const [loading, setLoading] = useState(false);
  const role = JSON.parse(localStorage.getItem("roles"));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const search = useSelector((state) => state.LeaveWithdrawalSlice.search);
  const { 
    searchText, 
    advancedLeave, 
    annualLeave,
    hospitalizationLeave,
    maternityLeave,
    paternityLeave,
    otherLeave,
    sickLeave,
    specialLeave,
    unpaidLeave 
  } = search;

  // Mapping helper: leave label to state key
  const getLeaveStateValue = (type) => {
    const map = {
      'Advanced Leave': advancedLeave,
      'Annual Leave': annualLeave,
      'Hospitalization Leave': hospitalizationLeave,
      'Maternity Leave': maternityLeave,
      'Paternity Leave': paternityLeave,
      'Other Leave': otherLeave,
      'Sick Leave': sickLeave,
      'Special Leave': specialLeave,
      'Unpaid Leave': unpaidLeave,
      'All': (
        advancedLeave &&
        annualLeave &&
        hospitalizationLeave &&
        maternityLeave &&
        paternityLeave &&
        otherLeave &&
        sickLeave &&
        specialLeave &&
        unpaidLeave
      )
    };
  
    return !!map[type]; // force boolean (true/false)
  };

  // Mapping helper: leave label to state key
  const leaveTypes = [
    'All',
    'Annual Leave',
    'Advanced Leave',
    'Sick Leave',
    'Special Leave',
    'Other Leave',
    'Unpaid Leave',
    'Maternity Leave',
    'Paternity Leave',
    'Hospitalization Leave'
  ];
  useEffect(() => {
    setLoading(true);

    if (!role || !role.includes("HR-L-WITHDRAWN")) {  // Check required role
      localStorage.clear(); 
      window.location.href = "/Login";
    }
    else {
      const entity = { ...search };
      dispatch(searchLeaveWithdrawalPagination({ body: entity, currentPage }))
      .then(() => {
        dispatch(searchLeaveWithdrawalPageCount(entity));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBtnSearch();
    }
  };

  const handleBtnSearch = () => {
    dispatch(updateCurrentPage(1));
    const entity = { ...search };
    dispatch(searchLeaveWithdrawalPagination({ body: entity, currentPage }))
    .then(() => {
      dispatch(searchLeaveWithdrawalPageCount(entity));
    })
    .catch(() => {
    });
  };

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleClickView = id => {
    navigate(`/LeaveWithdrawalForm/${id}`);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      const entity = { ...search };
      dispatch(searchLeaveWithdrawalPagination({ currentPage: currentPage - 1, body:entity }));
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      const entity = { ...search };
      dispatch(searchLeaveWithdrawalPagination({ currentPage: currentPage + 1, body:entity }));
    }
  };

  const handlePageChange = (page) => {
    dispatch(updateCurrentPage(page));
    const entity = { ...search };
    dispatch(searchLeaveWithdrawalPagination({ currentPage: page, body:entity }));
  };  

  const renderStaffList = () => {
    // const startIndex = (currentPage - 1) * pageSize;
    // const endIndex = Math.min(startIndex + pageSize, filteredList.length);

    return withdrawalList
      // .slice()
      // .sort((a, b) => new Date(b.created) - new Date(a.created))
      // .slice(startIndex, endIndex)
      .map(list => (
        <tr key={list.id} style={{ cursor: "pointer" }}>
          {isMobile ? (
            <>
              <td>
                <strong>
                  {list.leave_application.employee.fullname
                    .toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                </strong>
                <br />
                <strong>{list.leave_application.leave_type.description} ({list.leave_application.number_of_days}D)</strong>
                <br />
                <strong>From:</strong> {moment(list.leave_application.from_date.date).format("YYYY-MM-DD")} ({list.leave_application.from_ampm})
                <br />
                <strong>To:</strong> {moment(list.leave_application.to_date.date).format("YYYY-MM-DD")} ({list.leave_application.to_ampm})
                <br />
                <span title={list.leave_application.reason_for_application}>{list.leave_application.reason_for_application}</span>
              </td>

              {(list.leave_application.status.short_description === 'WITHDRAWN (HR)' || list.leave_application.status.short_description === 'APPROVED-HR') && (
                <td className="text-center align-middle">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{list.status.short_description}</Tooltip>}
                  >
                    <span>
                      <FontAwesomeIcon icon={faCheck} style={{ color: '#3fa64b' }} />
                    </span>
                  </OverlayTrigger>
                </td>
                
              )}

              {list.leave_application.status.short_description === 'WITHDRAWING' && (
                <td className="text-center align-middle">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{list.status.short_description}</Tooltip>}
                  >
                    <span>
                      <FontAwesomeIcon icon={faHourglass} style={{ color: '#FFD43B' }} />
                    </span>
                  </OverlayTrigger>
                </td>
              )}

              {list.leave_application.status.short_description === 'REVERT' && (
                <td className="text-center align-middle">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>REJECTED</Tooltip>}
                  >
                    <span>
                      <FontAwesomeIcon icon={faReply} style={{ color: '#f22c2c' }} />
                    </span>
                  </OverlayTrigger>
                </td>
              )}

              <td className="text-center align-middle" onClick={() => handleClickView(list.id)}>
                <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }}/>
              </td>
            </>
          ) : (
            <>
              <td>{moment(list.created).format('YYYY-MM-DD')}</td>
              {/* <td>{list.leave_application.employee.fullname}</td> */}
              <td>
                {list.leave_application.employee.fullname
                  .toLowerCase()
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')}
              </td>
              <td>{list.leave_application.leave_type.description}</td>
              <td>{list.leave_application.description}</td>

              {(list.leave_application.status.short_description === 'WITHDRAWN (HR)' || list.leave_application.status.short_description === 'APPROVED-HR') && (
                <td className="text-center align-middle">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{list.status.short_description}</Tooltip>}
                  >
                    <span>
                      <FontAwesomeIcon icon={faCheck} style={{ color: '#3fa64b' }} />
                    </span>
                  </OverlayTrigger>
                </td>
                
              )}

              {list.leave_application.status.short_description === 'WITHDRAWING' && (
                <td className="text-center align-middle">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{list.status.short_description}</Tooltip>}
                  >
                    <span>
                      <FontAwesomeIcon icon={faHourglass} style={{ color: '#FFD43B' }} />
                    </span>
                  </OverlayTrigger>
                </td>
              )}

              {list.leave_application.status.short_description === 'REVERT' && (
                <td className="text-center align-middle">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>REJECTED</Tooltip>}
                  >
                    <span>
                      <FontAwesomeIcon icon={faReply} style={{ color: '#f22c2c' }} />
                    </span>
                  </OverlayTrigger>
                </td>
              )}

              <td className="text-center align-middle" onClick={() => handleClickView(list.id)}>
                <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }}/>
              </td>
            </>
          )}
        </tr>
      ));
  };

  const handleSearch = (e) => {
    const entity = {...search, searchText: e.target.value};
    dispatch(updateSearch(entity));
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    let entity = { ...search, [name]: checked };
  
    // If "All" is unchecked, set all leave types to false
    if (name === 'all' && !checked) {
      entity = {
        ...search,
        annualLeave: false,
        advancedLeave: false,
        sickLeave: false,
        specialLeave: false,
        otherLeave: false,
        unpaidLeave: false,
        maternityLeave: false,
        paternityLeave: false,
        hospitalizationLeave: false,
      };
    }
  
    // If "All" is checked, set all leave types to true
    if (name === 'all' && checked) {
      entity = {
        ...search,
        annualLeave: true,
        advancedLeave: true,
        sickLeave: true,
        specialLeave: true,
        otherLeave: true,
        unpaidLeave: true,
        maternityLeave: true,
        paternityLeave: true,
        hospitalizationLeave: true,
      };
    }
    dispatch(updateSearch(entity));
  };  

  return (
    <div className="ContainerContent2">
      {loading2 && (
        <ThreeDots
          visible={loading2}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">HR Leave Withdrawals</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <InputGroup className="mb-3">
          <Form.Control placeholder="Search" name="searchText" value={searchText} onChange={handleSearch} onKeyPress={handleKeyPress} />
          <Button className="SearchIconBtn" onClick={handleBtnSearch}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroup>

        <div className="FormLabel">
          {leaveTypes.map((type) => (
            <Form.Check
              key={type}
              inline
              type="checkbox"
              label={type}
              name={
                type
                  .toLowerCase()
                  .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
                    index === 0 ? word.toLowerCase() : word.toUpperCase()
                  )
                  .replace(/\s+/g, '')
              }              
              value={type}
              checked={getLeaveStateValue(type)}
              onChange={handleCheckboxChange}
            />
          ))}
        </div>

        <br/>

        <div style={{ overflowX: 'auto' }}>
          <Table className="my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                {isMobile ? (
                  <>
                    <th style={{ width: "60px" }}>Leave Applications</th>
                    <th style={{ width: "30px" }} className="text-center align-middle">Status</th>
                    <th style={{ width: "10px" }} className="text-center align-middle">Edit</th>
                  </>
                ) : (
                  <>
                    <th style={{ width: "100px" }}>Date Applied</th>
                    <th style={{ width: "200px" }}>Employee</th>
                    <th style={{ width: "100px" }}>Type</th>
                    <th style={{ width: "220px" }}>Description</th>
                    <th style={{ width: "50px" }} className="text-center align-middle">Status</th>
                    <th style={{ width: "50px" }} className="text-center align-middle">
                      <FontAwesomeIcon icon={faBoltLightning} title="Action" />
                    </th>
                  </>
                )}
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {withdrawalList.length > 0 ? (
                  renderStaffList()
                ) : (
                  <tr>
                    {isMobile ? (
                      <>
                        <td colSpan="3">No results found</td>
                      </>
                    ) : (
                      <>
                        <td colSpan="6">No results found</td>
                      </>
                    )}
                  </tr>
                )}
              </tbody>
            )}
          </Table>

          <div className="legend-pagination-row">
            <div className="legend-container mb-2">
              <div className="legend-row">
                <span className="legend-item" style={{ fontSize: "14px" }}>
                  <FontAwesomeIcon icon={faHourglass} color="#FFC107" />&nbsp;Pending
                </span>
                <span className="legend-item" style={{ fontSize: "14px" }}>
                  <FontAwesomeIcon icon={faCheck} color="#28A744" />&nbsp;Approved
                </span>
                <span className="legend-item" style={{ fontSize: "14px" }}>
                  <FontAwesomeIcon icon={faReply} color="#DC3545" />&nbsp;Rejected
                </span>
              </div>
            </div>

            <div style={{ marginLeft: "auto" }}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>

          {/* <Table>
            <tbody>
              <tr>
                <td className="FormLabel">
                  <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                  &nbsp;Pending
                  &ensp;&ensp;
                  <FontAwesomeIcon icon={faCheck} color="#28A744" />
                  &nbsp;Approved
                  &ensp;&ensp;
                  <FontAwesomeIcon icon={faReply} color="#DC3545" />
                  &nbsp;Rejected
                </td>
              </tr>
            </tbody>
          </Table> */}
        </div>

        {/* <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        /> */}

        <div className="d-flex justify-content-between">
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};

export default LeaveWithdrawalList;
